var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    d: "M6.61787 9.41722C6.85224 8.86137 7.39678 8.5 8.00002 8.5H16C16.6032 8.5 17.1478 8.86137 17.3821 9.41722C17.6165 9.97306 17.4951 10.6152 17.074 11.0471C16.7941 11.3339 16.514 11.623 16.2333 11.9128C16.2333 11.9128 14.2627 13.9472 13.2286 14.9204C12.9683 15.1655 12.5679 15.5 12 15.5C11.4321 15.5 11.0317 15.1655 10.7714 14.9204C9.73816 13.948 7.76615 11.9122 7.76615 11.9122L7.76613 11.9122C7.48578 11.6228 7.2063 11.3343 6.92697 11.0481L6.92608 11.0472C6.50496 10.6153 6.3835 9.97306 6.61787 9.41722Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretX2);
export default __webpack_public_path__ + "static/media/CaretX2.827e8e5fdc7308e4e0d152a7def647d1.svg";
export { ForwardRef as ReactComponent };